
  var aui = window['aui'] = window['aui'] || {};
  // This file was automatically generated from template6.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace aui.message.
 */

if (typeof aui == 'undefined') { var aui = {}; }
if (typeof aui.message == 'undefined') { aui.message = {}; }


aui.message.info = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'info'}));
};
if (goog.DEBUG) {
  aui.message.info.soyTemplateName = 'aui.message.info';
}


aui.message.change = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'change'}));
};
if (goog.DEBUG) {
  aui.message.change.soyTemplateName = 'aui.message.change';
}


aui.message.warning = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'warning'}));
};
if (goog.DEBUG) {
  aui.message.warning.soyTemplateName = 'aui.message.warning';
}


aui.message.error = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'error'}));
};
if (goog.DEBUG) {
  aui.message.error.soyTemplateName = 'aui.message.error';
}


aui.message.success = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'success'}));
};
if (goog.DEBUG) {
  aui.message.success.soyTemplateName = 'aui.message.success';
}


aui.message.hint = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'hint'}));
};
if (goog.DEBUG) {
  aui.message.hint.soyTemplateName = 'aui.message.hint';
}


aui.message.generic = function(opt_data, opt_ignored) {
  return '' + aui.message.message(soy.$$augmentMap(opt_data, {type: 'generic'}));
};
if (goog.DEBUG) {
  aui.message.generic.soyTemplateName = 'aui.message.generic';
}


aui.message.message = function(opt_data, opt_ignored) {
  var output = '';
  var theTagName__soy24 = opt_data.tagName ? opt_data.tagName : 'div';
  var theType__soy25 = opt_data.type ? opt_data.type : 'generic';
  var labeledType__soy26 = theType__soy25 == 'error' || theType__soy25 == 'warning' || theType__soy25 == 'info' || theType__soy25 == 'confirmation' || theType__soy25 == 'change';
  output += '<' + soy.$$escapeHtml(theTagName__soy24) + ' role="note"' + ((opt_data.id) ? ' id="' + soy.$$escapeHtml(opt_data.id) + '"' : '') + ' class="aui-message aui-message-' + soy.$$escapeHtml(theType__soy25) + ' ' + soy.$$escapeHtml(theType__soy25) + ((opt_data.isCloseable) ? ' closeable' : '') + aui.renderExtraClasses(opt_data) + '"' + aui.renderExtraAttributes(opt_data) + '>' + ((opt_data.titleContent || labeledType__soy26) ? '<p class="title">' + ((! opt_data.a11yTypeLabel) ? ((theType__soy25 == 'error') ? '<strong hidden>' + soy.$$escapeHtml(AJS.I18n.getText('aui.messagecomponent.error.label')) + ': </strong>' : '') + ((theType__soy25 == 'warning') ? '<strong hidden>' + soy.$$escapeHtml(AJS.I18n.getText('aui.messagecomponent.warning.label')) + ': </strong>' : '') + ((theType__soy25 == 'info') ? '<strong hidden>' + soy.$$escapeHtml(AJS.I18n.getText('aui.messagecomponent.info.label')) + ': </strong>' : '') + ((theType__soy25 == 'confirmation') ? '<strong hidden>' + soy.$$escapeHtml(AJS.I18n.getText('aui.messagecomponent.confirmation.label')) + ': </strong>' : '') + ((theType__soy25 == 'change') ? '<strong hidden>' + soy.$$escapeHtml(AJS.I18n.getText('aui.messagecomponent.change.label')) + ': </strong>' : '') : '<strong hidden>' + soy.$$escapeHtml(opt_data.a11yTypeLabel) + ': </strong>') + ((opt_data.titleContent) ? '<strong>' + soy.$$filterNoAutoescape(opt_data.titleContent) + '</strong>' : '') + '</p>' : '') + soy.$$filterNoAutoescape(opt_data.content) + ((opt_data.isCloseable) ? '<span class="aui-icon icon-close" role="button" tabindex="0"></span>' : '') + '</' + soy.$$escapeHtml(theTagName__soy24) + '>';
  return output;
};
if (goog.DEBUG) {
  aui.message.message.soyTemplateName = 'aui.message.message';
}

        module.exports = aui.message;